import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { authorization } from 'Module/Auth/Auth'
import { getCityLink } from 'Utils/Link'
import { PageTitle } from 'Components/PageTitle'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { CityAddEditWrapper } from 'Components/City/CityAddEdit/Wrapper'
import EditCityDetails from '../../../Containers/Form/City/CityAddEdit/Edit/EditCityDetails/Controller'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { PATHS } from 'Config/Routing/paths'
import CitiesIcon from 'Assets/Images/icons/cities'
import { SectionWrapper } from '../../../Components/Section/SectionWrapper'
import BadWeather from '../../../Containers/Form/City/BadWeather'
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator'
import CityPromoCampaign from '../../Form/City/CityPrograms/CityPrograms/Promo'
import CityReferralCampaign from '../../Form/City/CityPrograms/CityPrograms/Referral'

const CityEdit = props => {
  if (!props.cityDataLoaded) return <LoadingIndicator />

  const isAdmin = authorization.isAdmin()

  return (
    <HideWhenBlocked>
      <CityAddEditWrapper>
        <LayoutDashboard>
          <Breadcrumbs icon={<CitiesIcon style={{ width: 16 }} />} />
          <Breadcrumb
            data={{
              title: 'Cities',
              pathname: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
            }}
          />
          <Breadcrumb
            data={{
              title: props.cityName,
              pathname: getCityLink(props.cityId, ' '),
            }}
          />
          <Breadcrumb
            data={{
              title: 'Edit',
              pathname: getCityLink(props.cityId, 'edit'),
            }}
          />
          <PageTitle>Edit City</PageTitle>
          <EditCityDetails {...props} />
          {isAdmin && (
            <SectionWrapper className="section-wrapper">
              <BadWeather cityId={props.cityId} />
            </SectionWrapper>
          )}
          {isAdmin && (
            <SectionWrapper className="section-wrapper">
              <CityReferralCampaign cityId={props.cityId} />
            </SectionWrapper>
          )}
          {isAdmin && (
            <SectionWrapper className="section-wrapper">
              <CityPromoCampaign cityId={props.cityId} />
            </SectionWrapper>
          )}
        </LayoutDashboard>
      </CityAddEditWrapper>
    </HideWhenBlocked>
  )
}

export { CityEdit }



// WEBPACK FOOTER //
// ./src/Containers/City/CityEdit/index.js